import { path } from "./path";

import type { IExtendedRouteObject } from "@routes/types.ts";
import { useUIStore } from "@/stores/uiStore";

// these are exluded from production
export const walletBalanceRoutes: IExtendedRouteObject[] = [
  {
    route: {
      path: path.walletBalance.route,
      lazy: () =>
        import(
          "@pages/panelPages/financialManagements/walletBalance/walletBalance"
        ),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(
            request,
            "pageTitle.financialManagements.walletBalance",
            [],
            "index",
            "main",
          );
        return {};
      },
    },
    permissions: ["patient", "inactive-patient"],
  },
];
